import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const TextField = styled(MuiTextField)({
  "& .MuiInputBase-root": {
    paddingLeft: "8px",
  },

  "& .MuiInputBase-input": {
    padding: "8px",
    background: "white",
    borderRadius: "12px",
    fontSize: "15px",
  },

  "& fieldset": {
    borderRadius: "12px",
    border: "1px solid #A0A0A0",

    "& legend": {
      fontSize: "14px",
    },
  },

  "& .MuiFormLabel-root": {
    fontSize: "18px",
    color: "#3961A0",
  },
});

export default TextField;
